<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Entrada y salida en cada visita. Mide
                el tiempo en tienda desde que llega la
                ruta hasta que se retira. Úsalo para
                analizar productividad y detectar
                visitas muy cortas o muy largas.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Ruteo
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Visualiza y exporta la duración de una visita en un <b>socio de negocio</b>.
        </div>
      </div>
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Reporte de Visitas</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Información">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="statusMoped">
              <span>Estado</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="statusMove">
              <span>Movimiento</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="statusBattery">
              <span>Batería</span>
            </button>
          </mat-menu>
          <mat-menu #statusMoped="matMenu">
            <button mat-menu-item style="cursor: text">
              <mat-icon style="color: #000000">moped</mat-icon>Sin Información
            </button>
            <button mat-menu-item style="cursor: text">
              <mat-icon style="color: #008000">moped</mat-icon>Libre
            </button>
            <button mat-menu-item style="cursor: text">
              <mat-icon style="color: #2a8ed1">moped</mat-icon>Ocupado
            </button>
          </mat-menu>
          <mat-menu #statusMove="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:flag" style="color: #9ca3af;"></mat-icon>
              <span>Sin información</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:flag" style="color:#ef4444"></mat-icon>
              <span>Detenido</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:flag" style="color:#22c55e"></mat-icon>
              <span>Activo</span>
            </button>
          </mat-menu>
          <mat-menu #statusBattery="matMenu">
            <button mat-menu-item style="cursor: text">
              <mat-icon style="color: #008000">battery_full</mat-icon> >
              70%
            </button>
            <button mat-menu-item style="cursor: text">
              <mat-icon style="color: #d0de35">battery_charging_full</mat-icon>
              30% - 70%
            </button>
            <button mat-menu-item style="cursor: text">
              <mat-icon style="color: #9f3f30">battery_alert</mat-icon>
              < 30% </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">

        <app-smart-grid [data]="dataSource.data" [columnDefs]="columnDefs" [config]="gridConfig" [loading]="false"
          [totalRecords]="totalItems" (gridReady)="onGridReady($event)" (pageChanged)="changePage($event)"
          (sortChanged)="changeSort($event)">
        </app-smart-grid>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row w-full mt-4 rounded-2xl overflow-hidden">
      <app-geo-manager #geoManagerTrip class="w-full h-full block" [zoom]="13" [center]="[51.505, -0.09]"
        [markerGroups]="filteredMarkerGroups" [displayMode]="'tooltip'" [captions]="{title: 'Viajes'}">
      </app-geo-manager>
    </div>
  </div>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="onClearFilter()"
    (onPanelOpened)="onFilterPanelOpened()">
    <app-dates-filters [form]="form" [showDateCreationRange]="true"></app-dates-filters>
    <app-routes-filters [form]="form" [route]="true" [loadData]="loadFiltersData"></app-routes-filters>
  </app-filter>
</mat-sidenav-container>